import { render, staticRenderFns } from "./NoteDialog.vue?vue&type=template&id=3b3ef33f&scoped=true&"
import script from "./NoteDialog.vue?vue&type=script&lang=js&"
export * from "./NoteDialog.vue?vue&type=script&lang=js&"
import style0 from "./NoteDialog.vue?vue&type=style&index=0&id=3b3ef33f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3ef33f",
  null
  
)

export default component.exports